export default "__VITE_ASSET__b04f8437__"